export const OrderByArray = ['name_asc', 'name_desc', 'date_asc', 'date_desc'] as const;
export type OrderByType = typeof OrderByArray[number];
